import { useQuery } from '@apollo/client';

import { GET_COMPONENT_DETAIL } from 'core/api/apollo/queries';

function useComponent(componentId, variantId = null) {
  const { loading, data: { getComponentDetail: componentDetail } = {} } = useQuery(GET_COMPONENT_DETAIL, {
    variables: { componentId, variantId },
  });

  return { loading, componentDetail };
}

export default useComponent;
